import PropTypes from 'prop-types';
import React from 'react';
import { Button } from 'react-toolbox';
import cx from 'classnames';

import styles from './coloredButton.scss';

const ColoredButton = ({ label, responsive, disabled, color, className, ...rest }) => {
  const buttonColor = disabled ? 'gray' : color;

  const filterClasses = cx(styles.button, className, styles[buttonColor], {
    [styles.responsive]: responsive,
  });

  return (
    <Button
      label={label}
      inverse
      disabled={disabled}
      className={filterClasses}
      {...rest}
    />
  );
};

ColoredButton.defaultProps = {
  label: '',
  responsive: false,
  disabled: false,
  color: 'green',
};

ColoredButton.propTypes = {
  label: PropTypes.string,
  color: PropTypes.string,
  responsive: PropTypes.bool,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  onClick: PropTypes.func,
};

export default ColoredButton;



// WEBPACK FOOTER //
// ./client/app/shared/components/ColoredButton/index.jsx